import React from 'react';
import { useAttachmentSentStatus } from 'core/attachments/hooks';
import { PillSelect } from 'modules/ui/components/new/PillSelect';

export interface IAttachmentSentStatusDropdownProps {
    attachmentId: number;
}

export const AttachmentSentStatusDropdown = ({ attachmentId }: IAttachmentSentStatusDropdownProps) => {
    const { isLoading, statusOptions, inputValue, handleStatusChange } = useAttachmentSentStatus(attachmentId);

    return (
        <PillSelect
            disabled={isLoading}
            options={statusOptions}
            value={inputValue}
            onValueChange={handleStatusChange}
        />
    );
};
